import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Event, Router } from '@angular/router';

@Component({
  selector: 'app-leftmenu',
  templateUrl: './leftmenu.component.html',
  styleUrls: ['./leftmenu.component.css']
})
export class LeftmenuComponent {

  public activemenu: any = '';

  constructor(public activateRoute: ActivatedRoute, public router: Router,) {
    window.scroll(0, 0);
  }

  ngOnInit() {
    console.log("activateRoutesss",  this.activemenu);
    

    if(this.activateRoute.snapshot.routeConfig?.path?.includes("dashboard")){
      this.activemenu = 'dashboard'
    }
    if(this.activateRoute.snapshot.routeConfig?.path?.includes("user-list")){
      this.activemenu = 'user-list'
    }


  
  
  }

  dashboardPage() {
    this.router.navigateByUrl('dashboard/admin-dashboard');
  }
 
  userListPage() {
    this.router.navigateByUrl('user-management/user-list');
  }

 

  
}